import { render, staticRenderFns } from "./SentenceDoctor.vue?vue&type=template&id=e7825ece&scoped=true&"
import script from "./SentenceDoctor.vue?vue&type=script&lang=js&"
export * from "./SentenceDoctor.vue?vue&type=script&lang=js&"
import style0 from "./SentenceDoctor.vue?vue&type=style&index=0&id=e7825ece&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7825ece",
  null
  
)

export default component.exports